export default "__VITE_ASSET__c5761d78__"